import { render, staticRenderFns } from "./PositionTexts.vue?vue&type=template&id=97a1b54c"
import script from "./PositionTexts.vue?vue&type=script&lang=js"
export * from "./PositionTexts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports